"use strict";

// Module API

function checkMaximum(constraint, value) {
  if (value === null) {
    return true;
  }
  if (value <= constraint) {
    return true;
  }
  return false;
}

module.exports = {
  checkMaximum: checkMaximum
};


//////////////////
// WEBPACK FOOTER
// ./~/tableschema/lib/constraints/maximum.js
// module id = 325
// module chunks = 0